import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {PopularCourseEligibilityService} from '../../../shared/services/popular-course-eligibility.service';
import {PopularCourseDurationSemesterService} from '../../../shared/services/popular-course-duration-semester.service';
import {UtilsService} from '../../../shared/services/utils.service';
import {environment} from '../../../../environments/environment';

interface EditorBlock {
    type: 'content' | 'table';
    value: string;
}

@Component({
    selector: 'app-popular-course-eligibility-duration',
    templateUrl: './popular-course-eligibility-duration.component.html',
    styleUrls: ['./popular-course-eligibility-duration.component.scss']
})
export class PopularCourseEligibilityDurationComponent implements OnInit {
    public popularCourseId: any;
    tinymceApiKey = environment.tinymceApiKey;

    tableEditorInit = {
        menubar: false,
        branding: false,
        plugins: 'lists link autolink charmap media searchreplace visualblocks wordcount codesample table',
        toolbar: 'undo redo | bold italic underline | bullist numlist | link media charmap | ' +
            'table tableinsertrowbefore tableinsertrowafter tabledeleterow tableinsertcolbefore tableinsertcolafter tabledeletecol | removeformat'
    };

    eligibilityBlocks: EditorBlock[] = [{type: 'content', value: ''}];
    eligibilitySubmitting: any = false;
    eligibilityDataExists: any = false;

    durationBlocks: EditorBlock[] = [{type: 'content', value: ''}];
    durationSubmitting: any = false;
    durationDataExists: any = false;

    constructor(private activatedRoute: ActivatedRoute,
                private popularCourseEligibilityService: PopularCourseEligibilityService,
                private popularCourseDurationSemesterService: PopularCourseDurationSemesterService) {
    }

    ngOnInit(): void {
        this.popularCourseId = this.activatedRoute.snapshot.parent.params['id'];
        this.refreshEligibility();
        this.refreshDuration();
    }

    private buildEditorBlocks(data): EditorBlock[] {
        const blocks: EditorBlock[] = (data && data['info']) ? UtilsService.splitEditorBlocks(data['info']) : [];
        if (data && data['table_html']) {
            blocks.push({type: 'table', value: data['table_html']});
        }
        return blocks.length ? blocks : [{type: 'content', value: ''}];
    }

    refreshEligibility() {
        this.popularCourseEligibilityService.detailByAdmin(this.popularCourseId).subscribe(data => {
            this.eligibilityDataExists = !!(data && data['info']);
            this.eligibilityBlocks = this.buildEditorBlocks(data);
        });
    }

    refreshDuration() {
        this.popularCourseDurationSemesterService.detailByAdmin(this.popularCourseId).subscribe(data => {
            this.durationDataExists = !!(data && data['info']);
            this.durationBlocks = this.buildEditorBlocks(data);
        });
    }

    addEligibilityBlock(editor: 'content' | 'table') {
        this.eligibilityBlocks.push({type: editor, value: ''});
    }

    removeEligibilityBlock(index: number) {
        this.eligibilityBlocks.splice(index, 1);
    }

    addDurationBlock(editor: 'content' | 'table') {
        this.durationBlocks.push({type: editor, value: ''});
    }

    removeDurationBlock(index: number) {
        this.durationBlocks.splice(index, 1);
    }

    submitEligibility() {
        const params = {
            'info': UtilsService.encodeHtml(UtilsService.joinEditorBlocks(this.eligibilityBlocks)) || '',
            'table_html': ''
        };
        this.eligibilitySubmitting = true;
        if (this.eligibilityDataExists) {
            this.popularCourseEligibilityService.updateByAdmin(this.popularCourseId, params).subscribe(data => {
                this.eligibilitySubmitting = false;
            }, error => {
                this.eligibilitySubmitting = false;
            });
        } else {
            this.popularCourseEligibilityService.createByAdmin(this.popularCourseId, params).subscribe(data => {
                this.eligibilitySubmitting = false;
                this.eligibilityDataExists = true;
            }, error => {
                this.eligibilitySubmitting = false;
            });
        }
    }

    submitDuration() {
        const params = {
            'info': UtilsService.encodeHtml(UtilsService.joinEditorBlocks(this.durationBlocks)) || '',
            'table_html': ''
        };
        this.durationSubmitting = true;
        if (this.durationDataExists) {
            this.popularCourseDurationSemesterService.updateByAdmin(this.popularCourseId, params).subscribe(data => {
                this.durationSubmitting = false;
            }, error => {
                this.durationSubmitting = false;
            });
        } else {
            this.popularCourseDurationSemesterService.createByAdmin(this.popularCourseId, params).subscribe(data => {
                this.durationSubmitting = false;
                this.durationDataExists = true;
            }, error => {
                this.durationSubmitting = false;
            });
        }
    }
}
